module.exports = __webpack_public_path__ + "img/video-message.a0b961f9.webp";